import Service from '@/service/aqr'
import { openChat } from '@/data/im'

export default {
    data() {
        return {
            float_questions: []
        }
    },
    methods: {
        getFloatQuestions(entry) {
            if (!this.float_questions || !this.float_questions.length) {
                Service.getQuestions(entry).then((data) => {
                    this.float_questions = data.items
                })
            }
        },
        selectFloatQuestion(id, params = {}) {
            Service.selectQuestion(id, params).then((data) => {
                openChat(data.consultant_id, {
                    recommend_aqr_id: data.id,
                    from: '提问咨询',
                    ...params
                })
            })
        }
    }
}
